export default "__VITE_ASSET__b3a56404__"